module.exports = __webpack_public_path__ + "static/swan-6c1570a8c435a218eddf91fccfd78ac0.jpg";